// extracted by mini-css-extract-plugin
module.exports = {"linkedHeading":"LinkedHeading_linkedHeading__3UaRu","heading":"LinkedHeading_heading__KG779","headingLinkIcon":"LinkedHeading_headingLinkIcon__f_7uQ"};